export default "__VITE_ASSET__C_SC0Bko__"